import axios from "../axios";

const login = async (data) => {
  const response = await axios({
    method: "post",
    url: `/api/admin/login`,
    data,
  });
  return response.data;
};

const logout = async () => {
  const response = await axios({
    method: "delete",
    url: `/api/user/logout`,
  });
  return response.data;
};

export { login, logout };

